import React from 'react'
import { connect } from 'react-redux'
import {
  Icon,
  Popup
} from 'semantic-ui-react'
// Local
import {
  hasExpiredQuery,
  hasCoderQueryNote,
  condition as conditionUtils
} from '../../common/conditionUtils'
import { coderQueryExpireHours } from '../../common/currentUserUtils'
import { EncounterConditionDisplay } from '../../authenticated/types'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  condition: EncounterConditionDisplay,
  popup?: string | undefined
}

function ConditionQueryStatusIcon(
  props: Props
): JSX.Element | null {
  const {
    condition,
    currentUser,
    popup
  } = props

  const expireHours = coderQueryExpireHours(currentUser)

  const isQueryExpired = hasExpiredQuery(condition, expireHours)

  const popupMessageContent = (): string => {
    if (isQueryExpired) {
      return `Condition has an Outstanding Query Waiting Longer Than ${expireHours} Hours`
    }
    if (conditionUtils.hasQuery(condition)) {
      return popup || 'Condition has an Outstanding Query'
    }
    if (hasCoderQueryNote(condition)) {
      return 'Condition has a Coder Query Note'
    }
    return ''
  }

  const popupMessage = popupMessageContent()

  if (!popupMessage) return null

  const iconColor = isQueryExpired
    ? 'red'
    : undefined

  return (
    <Popup
      content={ popupMessage }
      mouseEnterDelay={ 1000 }
      trigger={
        <Icon
          name="comment alternate outline"
          color={ iconColor }
        />
      }
    />
  )
}

export default connect(mapStateToProps)(ConditionQueryStatusIcon)
